// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___2kXza","container":"styles__container___37T86","arrows":"styles__arrows___-_Wj_"};